import { DestroyRef, Directive, inject } from "@angular/core";

/**
 * Abstract base directive for Angular components that hold RxJS subscriptions.
 *
 * Exposes `destroyRef` so subclasses can pass it to `takeUntilDestroyed()`:
 *
 * ```ts
 * this.data$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(…);
 * ```
 *
 * The `@Directive()` decorator is required for Angular to participate in DI
 * and resolve `inject()` calls defined in this base class.
 */
@Directive()
export abstract class BaseDestroyableComponent {
  protected readonly destroyRef = inject(DestroyRef);
}
